import { render, staticRenderFns } from "./ReferencesTable.vue?vue&type=template&id=2cde3984&scoped=true"
import script from "./ReferencesTable.vue?vue&type=script&lang=js"
export * from "./ReferencesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde3984",
  null
  
)

export default component.exports